export enum IdentityServerUserRoles {
    ACCOUNTADMIN = 'AccountAdmin',
    ACCOUNTIMPERSONATION = 'AccountImpersonation',
    DELEGATEDACCOUNTADMIN = 'DelegatedAccountAdmin',
    MAINTENANCEADMIN = 'MaintenanceAdmin',
    SUPPORTADMIN = "SupportAdmin"
}
